module.exports = __webpack_public_path__ + "media/old_images/icon-play@2x-85f4280d.png";